import { render, staticRenderFns } from "./pitcherLog.vue?vue&type=template&id=53e81be5&scoped=true"
import script from "./pitcherLog.vue?vue&type=script&lang=js"
export * from "./pitcherLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e81be5",
  null
  
)

export default component.exports